/* eslint-disable no-prototype-builtins */
var XPortal = XPortal || {};
XPortal.EntityFilterPicker = (function () {
    var localizedMessages = { where: "Where", or: "Or", and: "And" };
    var self = {
        emptyFieldValueText: "___empty___",
        FilterTypes: {
            undefined: -1,
            eq: 0,
            neq: 1,
            startswith: 2,
            contains: 3,
            doesnotcontain: 4,
            endswith: 5,
            unique: 6,
            lt: 30,
            lte: 30,
            gte: 40,
            gt: 40,
            blank: 50,
            notblank: 60,
            ltc: 100,
            eqc: 110,
            gtc: 120,
            isgtedys: 210,
            isltedys: 215,
            iseqldys: 220,
            isgtehrs: 225,
            isltehrs: 230,
            iseqlhrs: 235,
        },
        AdditionalDateOperators: [{
            value: "ltc",
            name: 'Is before current date',
            IsPeriodic: true
        },
        {
            value: "eqc",
            name: 'Is equals to current date',
            IsPeriodic: true,
            IsValueVisible: false
        },
        {
            value: "gtc",
            name: 'Is after current date',
            IsPeriodic: true
        },
        {
            value: "isgtedys",
            name: 'Is greater than(days)',
            IsPeriodic: true
        },
        {
            value: "isltedys",
            name: 'Is less than(days)',
            IsPeriodic: true
        },
        {
            value: "iseqldys",
            name: 'Is equals with(days)',
            IsPeriodic: true
        }],
        AdditionalDateTimeOperators: [
            {
                value: "ltc",
                name: 'Is before current date',
                IsPeriodic: true
            },
            {
                value: "eqc",
                name: 'Is equals to current date',
                IsPeriodic: true,
                IsValueVisible: false
            },
            {
                value: "gtc",
                name: 'Is after current date',
                IsPeriodic: true
            },
            {
                value: "isgtehrs",
                name: 'Is greater than(hours)',
                IsPeriodic: true
            },
            {
                value: "isltehrs",
                name: 'Is less than(hours)',
                IsPeriodic: true
            },
            {
                value: "iseqlhrs",
                name: 'Is equals with(hours)',
                IsPeriodic: true
            }
        ],
        ControlSelector: ".entityFilterPicker",
        Init: function (options) {
            options = options || {};
            options.container = options.container ? options.container : $(XPortal.Main.DetialFormSelector);

            options.container.find(self.ControlSelector).each(function (_ip, element) {
                options.element = element;
                XPortal.GridFiltering.Init().then(() => {
                    self.initFor(options, XPortal.Store.getModelName(options.container[0].id));
                });
            });
        },

        initFor: function (options, modelName) {
            const $filterPicker = $(options.element);
            const $filterPickerContainer = $filterPicker.is(".filters-list-wrapper") ? $filterPicker.parent() : $filterPicker.closest(".filters-list-wrapper").parent();
            const $fieldsPicker = $filterPickerContainer.find(".fieldsContainer");

            const $valueControl = $("input[name=" + $filterPicker.attr("valuecontrol") + "]");
            const $pageIdControl = $("input[data-metadata-fieldname=RelatedPageId]");
            const $listIdControl = $("input[data-metadata-fieldname=RelatedListId]");
            const $pageRelatedAliasControl = $("input[data-metadata-fieldname=RelatedEntityAlias]");
            $($filterPicker.parent().find(".filter-list-buttons")[0]).removeClass("display-filters");
            options = { ...options, ...XPortal.Main.GetSettingsFor($valueControl) }

            const editNodeId = XPortal.Store.GetModelByName(modelName).model.NodeId;
            if ($valueControl.length < 1) return;
            options = {
                ...options,
                element: options.element,
                selectAllFields: options.selectAllFields,
                fieldsElement: $fieldsPicker,
                valueControl: $valueControl,
                data: JSON.stringify({
                    RelatedPageId: $listIdControl.val() > 0 ? $listIdControl.val() : 0,
                    EntityAlias: $pageRelatedAliasControl.attr("data-value"),
                    NodeId: editNodeId
                }),
                url: $valueControl.attr("data-src"),
                modelName: modelName
            };
            self.Call(options, self.BindControl, null, self.BindControl);
        },
        MapEnumToInt: function (filter) {
            var filterType = filter.FilterType;
            filter.FilterType = self.FilterTypes[filterType];
            if (filterType === "gte") {
                filter.IncludeLower = true;
                filter.IncludeUpper = true;
            }
            else if (filterType === "lte") {
                filter.IncludeUpper = true;
            }
            else if (filterType === "neq") {
                filter.Not = true;
                filter.FilterType = self.FilterTypes["eq"];
            }
            // TODO: add validation here
            else if (filterType === "notblank") {
                filter.FilterType = self.FilterTypes["eq"];
                filter.Not = true;
                filter.Value = self.emptyFieldValueText;
                if (filter.hasOwnProperty("value")) delete filter.value;
            }
            else if (filterType === "blank") {
                filter.FilterType = self.FilterTypes["eq"];
                filter.Value = self.emptyFieldValueText;
                if (filter.hasOwnProperty("value")) delete filter.value;
            }
            filter.FieldName = filter.FieldName.toLowerCase();
            filter.IsValid = true;
        },
        MapIntToEnum: function (filter) {
            var filterType = filter.FilterType;
            let ft = Object.keys(self.FilterTypes).find(key => self.FilterTypes[key] === filterType);
            filter.FilterType = ft;
            if (ft === "gt" && filter.IncludeLower && filter.IncludeUpper) {
                filter.FilterType = "gte";
                delete filter.IncludeLower;
                delete filter.IncludeUpper;
            }
            else if (ft === "lt" && filter.IncludeUpper === true) {
                delete filter.IncludeUpper;
                filter.FilterType = "lte";
            }
            else if (ft === "eq" && filter.Value === self.emptyFieldValueText) {
                filter.FilterType = filter.Not !== true ? "blank" : "notblank";
                filter.Value = "";
            } else if (ft === "eq" && filter.Not === true) {
                filter.FilterType = "neq";
                delete filter.IsAnd;
                delete filter.Not;
            }
        },
        MapBeforeSave: function (options) {
            var filters = [];
            var params = JSON.parse(options.data);
            options.gridFilterModel.filters = self.ChangeGroupPeriodic(options.gridFilterModel.filters);
            var listQueryField = options.gridFilterModel.filters.map(f => {
                var qf = self.MapFilterDataToViewModel(f);
                var filter = {
                    Value: !f.operator || (f.operator.value === "notblank" || f.operator.value === "blank") ? "" : !f.value && f.value != 0 ? f.advancedOperator : f.value,
                    Field: f.field,
                    Logic: f.conditionDropDown,
                    Operator: f.operator,
                    Type: f.IsBoolean ? "eq" : !f.operator || f.operator.value == null ? f.operator : f.operator.value
                };
                qf.IsPeriodic = f.additionalType && f.additionalType === "period";
                if (qf.IsPeriodic) {
                    qf.Value = f.value = f.advancedOperator;
                    
                    filter = XPortal.GridFiltering.ProcessDateFilter(f);                    
                }
                if (filter) filters.push(filter);
                return qf;
            });
            var listSelectedField = options.fieldsModel.fields ? options.fieldsModel.fields.filter(f => f.selected === true).map(f => { return { FieldName: f.field, Selected: f.selected }; }) : null;
            var conditionsObj = JSON.stringify({ QueryFields: listQueryField, TrackFields: listSelectedField, EntityType: params.EntityAlias, Filters: filters });
            options.valueControl.val(conditionsObj);
            XPortal.Store.DispatchFieldEditorEvent(options.valueControl, conditionsObj, options.modelName);
            //make empty related fields uid
            if (options.gridFilterModel.filters.length > 0) {
                $("input[data-metadata-fieldname=RelatedEntityAllKeys]").val("");
                $("input[data-metadata-fieldname=RelatedEntityUniqueId]").val("00000000-0000-0000-0000-000000000000");
            }
        },
        MapFilterDataToViewModel: function (f) {
            var r = { conditionDropDown: f.conditionDropDown, FieldName: f.field.toLowerCase(), Operator: f.operator, IsPeriodic: f.IsPeriodic };
            r.FilterType = f.FilterType ? f.FilterType : (f.IsBoolean ? "eq" : !f.operator || f.operator.value == null ? f.operator : f.operator.value);
            r.Value = !f.operator || (f.operator.value === "notblank" || f.operator.value === "blank") ? "" : !f.value && f.value != 0 ? f.advancedOperator : f.value;
            self.MapEnumToInt(r);
            if (f.Value != null && (f.FieldType === "date" || f.FieldType === "datetime")) {
                if (typeof f.value.getTimezoneOffset === "function" && f.value.getTimezoneOffset() && !f.operator.endsWith("blank")) {
                    r.Value = f.value === null ? (f.advancedOperator || '') : XPortal.Utils.customISOstring(f.value, f.value.getTimezoneOffset());
                }
            }
            return r;
        },
        MapFieldType: function (inputType) {
            if (inputType === "timestamp") return "time";
            var numberTypes = ["int", "int32", "int64", "long", "decimal", "float", "i", "l", "integer"];
            if (numberTypes.indexOf(inputType) > -1) return "number";
            return inputType;
        },
        GetGroupElements: function (allItems) {
            let groupFilters = [];
            for (let i = allItems.length - 1; i >= 0; i--) {
                let item = allItems[i];
                if (item.field != "___group___") groupFilters.push(item);
                else break;
            }
            return groupFilters;
        },
        GetGroupElementsForCurent: function (allItems, element) {
            let currentIndex = allItems.indexOf(element);
            let groupFilters = [];
            for (let i = currentIndex; i >= 0; i--) {
                if (currentIndex == i) continue;
                let item = allItems[i];
                if (item.field != "___group___") groupFilters.push(item);
                else break;
            }

            for (let i = currentIndex; i < allItems.length; i++) {
                if (currentIndex == i) continue;
                let item = allItems[i];
                if (item.field != "___group___") groupFilters.push(item);
                else break;
            }

            return groupFilters;
        },
        UpdateCondition: function (allFilters) {
            for (let i = 0; i < allFilters.length; i++) {
                let item = allFilters[i];
                let groupElements = XPortal.EntityFilterPicker.GetGroupElementsForCurent(allFilters, item);
                if (item.field == "___group___") continue;
                if (i > 0 && allFilters[i - 1].field == "___group___") allFilters[i].conditionDropDown = localizedMessages.and;
                else {
                    let conditionValue = groupElements.filter(f => f.field.toLowerCase() === item.field.toLowerCase()).length > 0 ? localizedMessages.or : item.conditionDropDown;
                    allFilters[i].conditionDropDown = conditionValue;
                }
            }
            return allFilters;
        },
        CleanUpEmptyGroups: function (allFilters, removeLastGroup) {
            var i = 0;
            while (i < allFilters.length - 1) {
                if (allFilters[i].field === "___group___" && allFilters[i].field == allFilters[i + 1].field) {
                    allFilters.splice(i, 1);
                    i = 0;
                } else i++;
            }
            if (removeLastGroup) {
                if (allFilters.length > 0 && allFilters[allFilters.length - 1].field === "___group___") allFilters.splice(allFilters.length - 1, 1);
            }
            return allFilters;
        },
        SortGroups: function (allFilters) {
            let result = [];
            let temporaryGroup = [];
            for (let i = 0; i < allFilters.length; i++) {
                let item = allFilters[i];
                if (item.field == "___group___") {
                    result.push(...temporaryGroup);
                    temporaryGroup = [];
                    result.push(item);
                }
                else {
                    temporaryGroup.push(item);
                }
            }
            return result;
        },
        CreateFirstFilter: function (gridColumns) {
            let firstFilter = {
                FieldName: "___group___",
                FilterType: 0,
                IsValid: true,
                conditionDropDown: "Where"
            };
            let workingRows = [];
            self.MapIntToEnum(firstFilter);
            let row = { field: firstFilter.FieldName, operator: firstFilter.FilterType, value: firstFilter.Value, Initialized: false };
            workingRows.push(row);
            let preparedRow = XPortal.GridFiltering.MapFilterRow({ row: row, columns: null, filters: workingRows }, gridColumns);
            preparedRow.conditionDropDown = firstFilter.conditionDropDown;
            preparedRow.IsPeriodic = false;
            return preparedRow;
        },
        BindControl: function (options, xdata) {
            var eFields = (xdata.EntityFields || []).concat([{ field: "___group___", type: "unknown" }]);
            $(options.element.parentElement).find("#addFilters").prop('disabled', !xdata.EntityFields || xdata.EntityFields.length === 0);
            var gridColumns = eFields
                .map(f => {
                    if (f.title === "") f.title = f.field;
                    f.type = f.type.toLowerCase();
                    f.selected = options.selectAllFields || false;
                    return f;
                })
                .filter(col => col.type && col.field);
            for (var i = 0; i < self.AdditionalDateOperators.length; i++) {
                var oi = self.AdditionalDateOperators[i];
                var ext = XPortal.GridFiltering.Operators["date"].find(x => x.value == oi.value);
                if (!ext) XPortal.GridFiltering.Operators["date"].push(oi);
            }
            for (var i = 0; i < self.AdditionalDateTimeOperators.length; i++) {
                var oi = self.AdditionalDateTimeOperators[i];
                var ext = XPortal.GridFiltering.Operators["datetime"].find(x => x.value == oi.value);
                if (!ext) XPortal.GridFiltering.Operators["datetime"].push(oi);
            }
            var value = options.valueControl.val();
            try {
                while (value.startsWith('{\\')) value = JSON.parse('"' + value + '"');
                var filterSettings = value !== "" ? JSON.parse(value) : { QueryFields: [] };
                options.filters = [];
                var workingRows = [];
                if (filterSettings.QueryFields && filterSettings.QueryFields.length > 0) {

                    if (filterSettings.QueryFields[0].FieldName != "___group___") options.filters.push(self.CreateFirstFilter(gridColumns));
                    var ix = 0;
                    filterSettings.QueryFields.forEach((f) => {
                        if (!f) return;
                        f = f.Items && f.Items.length == 1 ? f.Items[0] : f;
                        self.MapIntToEnum(f);
                        let row = { conditionDropDown: f.conditionDropDown, field: f.FieldName, operator: f.FilterType, value: f.Value, isFirst: ix++ == 0, Initialized: false };
                        row.additionalType = XPortal.GridFiltering.AdditionalGridOperators.find(x => x.value == row.value) ? "period" : "";
                        workingRows.push(row);
                        let preparedRow = XPortal.GridFiltering.MapFilterRow({ row: row, filters: workingRows, conditionDropDown: f.conditionDropDown }, gridColumns);
                        if (preparedRow.Initialized | preparedRow.field == "___group___")
                            options.filters.push(preparedRow);
                    });
                }
                if ((filterSettings.TrackFields || []).length > 0)
                    gridColumns.map(col => {
                        return col.selected = filterSettings.TrackFields.find(f => f.FieldName === col.field) ? true : false;
                    });
            }
            catch (error) {
                if (console && console.error) console.error(error);
            }
            var fieldsModel = new kendo.observable({
                fields: xdata.EntityFields,
                selectedFieldsText: function () {
                    var curFields = this.get("fields");
                    if (!curFields || curFields.length == 0)
                        return "(0/0)";

                    var selectedLen = this.get("fields").filter(col => col.selected === true).length;
                    return "(" + selectedLen + "/" + xdata.EntityFields.length + ")";
                },
                allSelected: function () {
                    var cols = this.get("fields");
                    return !cols || cols.length > 0 && cols.find(({ selected }) => selected !== true) ? false : true;
                },
                selectAllClick: function () {
                    var cols = this.get("fields");
                    let allSelected = this.get("allSelected()");
                    cols.forEach(c => { c.selected = !allSelected; });
                    kendo.unbind(options.fieldsElement);
                    kendo.bind(options.fieldsElement, fieldsModel);
                }
            });
            fieldsModel.bind("change", function (e) {
                options.gridFilterModel = gridFilterModel;
                options.fieldsModel = fieldsModel;
                self.MapBeforeSave(options);
            });
            kendo.unbind(options.fieldsElement);
            kendo.bind(options.fieldsElement, fieldsModel);
            if (!options.editable)
                $(options.fieldsElement).find(".checkbox").each(function () { $(this).prop("disabled", "disabled") });

            var gridFilterModel = new kendo.observable({
                columns: fieldsModel.fields,
                filters: options.filters ? options.filters : [],
                deleteRow: function (e) {
                    if (!$(e.target).hasClass("close"))
                        return;
                    var picker = $(e.currentTarget.closest(".entityFilterPicker"));
                    var uid = e.currentTarget.dataset["uid"];
                    var filters = picker.get(0).kendoBindingTarget.source.filters;
                    var itemIndex = filters.map(f => f.uid).indexOf(uid);
                    var item = filters.find(f => f.uid);
                    if (item.field == "___group___") {
                        var lastRecorsIndex = itemIndex + 1;
                        for (var i = itemIndex; i < filters.length; i++) {
                            if (i + 1 == filters.length) break;
                            var deleteItem = filters[i + 1];
                            if (deleteItem.field != "___group___") {
                                lastRecorsIndex++;
                            }
                            else if (deleteItem.field == "___group___") {
                                break;
                            }
                        }
                        filters.splice(itemIndex, lastRecorsIndex - itemIndex);
                    }
                    else if (itemIndex > -1) {
                        filters.splice(itemIndex, 1);
                    }
                    XPortal.CustomLogic.NotificationsLogic.AdjustDetailsEditorFields({ filters: filters, modelName: options.modelName });
                },
                addFilter: function (e) {
                    var uid = e.currentTarget.dataset["uid"];
                    var picker = $(e.currentTarget.closest(".entityFilterPicker"));
                    var filters = picker.get(0).kendoBindingTarget.source.filters;
                    var itemIndex = filters.map(f => f.uid).indexOf(uid);

                    if (options.gridFilterModel.filters.length == 0) {
                        XPortal.EntityFilterPicker.AddGroupLine(null, options);
                    }
                    options = options ? options : { element: e.data.element, gridFilterModel: e.data.gridFilterModel };
                    var field = { field: options.gridFilterModel.columns[0].field };
                    var mappedFilter = XPortal.GridFiltering.MapFilterRow({
                        row: field, filters: [field]
                    }, options.gridFilterModel.columns);
                    mappedFilter.conditions = XPortal.GridFiltering.conditionsDropDown(options.gridFilterModel.filters.length);
                    if (mappedFilter.operators && mappedFilter.operators.length > 0) {
                        mappedFilter.operator = mappedFilter.operators[0].value;
                    }
                    var groupElements = XPortal.EntityFilterPicker.GetGroupElements(options.gridFilterModel.filters);
                    mappedFilter.conditionDropDown = groupElements.filter(f => f.field.toLowerCase() === mappedFilter.field.toLowerCase()).length > 0 ? localizedMessages.or : localizedMessages.and;

                    var lastRecorsIndex = itemIndex + 1;
                    for (var i = lastRecorsIndex; i < filters.length; i++) {
                        if (i == filters.length) break;
                        var nextItem = filters[i];
                        if (nextItem.field != "___group___") {
                            lastRecorsIndex++;
                        }
                        else if (nextItem.field == "___group___") {
                            break;
                        }
                    }

                    if (lastRecorsIndex > 0 && filters[lastRecorsIndex - 1].field == "___group___") mappedFilter.hideCondition = true;
                    options.gridFilterModel.filters.splice(lastRecorsIndex, 0, mappedFilter);
                    options.gridFilterModel.filters.forEach(function (x) {
                        x.hideCondition = false;
                    });
                    kendo.unbind(options.element);
                    kendo.bind(options.element, options.gridFilterModel);
                    XPortal.CustomLogic.NotificationsLogic.AdjustDetailsEditorFields({ filters: options.gridFilterModel.filters, modelName: options.modelName });


                }
            });
            gridFilterModel.bind("change", function (e) {
                if (e.items.length > 0) {

                    var changedUid = e.items[0].uid;
                    if (e.action === "itemchange") {
                        var row = e.sender.filters.find(f => f.uid === changedUid);
                        if (row)
                            XPortal.GridFiltering.MapFilterRow({
                                row: e.sender.filters.find(f => f.uid === changedUid), filters: e.sender.filters, conditionDropDown: row.conditionDropDown
                            }, gridFilterModel.columns);

                        XPortal.CustomLogic.NotificationsLogic.AdjustDetailsEditorFields({ filters: e.sender.filters, modelName: options.modelName });
                    }
                    gridFilterModel.filters = self.UpdateCondition(self.CleanUpEmptyGroups(gridFilterModel.filters, true));
                    gridFilterModel.filters = self.UpdateEditable(gridFilterModel.filters, options.editable);
                    options.gridFilterModel = gridFilterModel;
                    options.fieldsModel = fieldsModel;
                    self.MapBeforeSave(options);
                    kendo.unbind(options.element);
                    kendo.bind(options.element, gridFilterModel);
                }
            });

            options.gridFilterModel = gridFilterModel;
            if (gridFilterModel.filters.length > 0 && gridFilterModel.filters.length < 2 && gridColumns.length > 1)
                gridFilterModel.filters.push(self.CreateDefaultFilterToGroup(options));


            gridFilterModel.filters = XPortal.GridFiltering.MarkAsFirstOperatorInGroup(gridFilterModel.filters);
            gridFilterModel.filters = self.UpdateConditions(self.CleanUpEmptyGroups(gridFilterModel.filters));
            gridFilterModel.filters = self.UpdateEditable(gridFilterModel.filters, options.editable);
            kendo.unbind(options.element);
            kendo.bind(options.element, gridFilterModel);

            options.fieldsModel = fieldsModel;
            $("#addFilters").off("click").on("click", function () {
                self.AddFilterLine(null, options);
            });
            $("#addGroup").off("click").on("click", function () {
                self.AddGroupLine(null, options);
            });
            XPortal.CustomLogic.NotificationsLogic.AdjustDetailsEditorFields({ filters: gridFilterModel.filters, modelName: options.modelName });
            var $uniqueIdControl = $("[data-metadata-fieldname=RelatedEntityUniqueId]");
            var $allKeysControl = $("[data-metadata-fieldname=RelatedEntityAllKeys]");
            $uniqueIdControl.off("change").on("change", function () {
                XPortal.CustomLogic.NotificationsLogic.AdjustDetailsEditorFields({ filters: gridFilterModel.filters, modelName: options.modelName });
            });
            $allKeysControl.off("change").on("change", function () {
                XPortal.CustomLogic.NotificationsLogic.AdjustDetailsEditorFields({ filters: gridFilterModel.filters, modelName: options.modelName });
            });

            options.valueControl.off("before-save").on("before-save", function (e, data) {
                e.preventDefault();
                self.MapBeforeSave(options);
                e.ondone(e);
            });
        },
        ChangeGroupPeriodic: function (filters) {
            var currentPeriodic = false;
            var endIndex = filters.length - 1;
            for (var i = endIndex; i >= 0; i--) {
                let filter = filters[i];
                if (filter.IsPeriodic) currentPeriodic = true;
                if (filter.field == "___group___" && currentPeriodic) {
                    filters[i].IsPeriodic = true;
                    currentPeriodic = false;
                }
            }
            return filters;
        },
        AddFilterLine: function (e, options, kgridData, fieldNameToSelect) {
            options = options ? options : { element: e.data.element, gridFilterModel: e.data.gridFilterModel };
            if (options.gridFilterModel.filters.length == 0)
                XPortal.EntityFilterPicker.AddGroupLine(null, options);
            var field = { field: fieldNameToSelect ? fieldNameToSelect : options.gridFilterModel.columns[0].field };
            var mappedFilter = XPortal.GridFiltering.MapFilterRow({
                griddata: kgridData,
                row: field, filters: [field],
                conditions: XPortal.GridFiltering.conditionsDropDown(options.gridFilterModel.filters.length)
            }, options.gridFilterModel.columns);
            if ((mappedFilter.operators || []).length > 0) mappedFilter.operator = mappedFilter.operators[0].value;

            var groupElements = XPortal.EntityFilterPicker.GetGroupElements(options.gridFilterModel.filters);
            mappedFilter.conditionDropDown = groupElements.filter(f => f.field.toLowerCase() === mappedFilter.field.toLowerCase()).length > 0 ? localizedMessages.or : localizedMessages.and;
            options.gridFilterModel.filters.push(mappedFilter);
            kendo.unbind(options.element);
            kendo.bind(options.element, options.gridFilterModel);
            XPortal.CustomLogic.NotificationsLogic.AdjustDetailsEditorFields({ filters: options.gridFilterModel.filters, modelName: options.modelName });
        },
        AddGroupLine: function (e, options, kgridData) {
            const mappedFilter = self.CreateGroupLine(options, kgridData);
            const defaultFilter = self.CreateDefaultFilterToGroup(options);

            options.gridFilterModel.filters.push(...[mappedFilter, defaultFilter]);
            
            
            kendo.unbind(options.element);
            kendo.bind(options.element, options.gridFilterModel);
        },
        CreateGroupLine: function (options, kgridData) {
            var mappedFilter = XPortal.GridFiltering.MapFilterRow({
                griddata: kgridData,
                row: { field: "___group___" },
                filters: ["___group___"],
                conditions: XPortal.GridFiltering.conditionsDropDown(options.gridFilterModel.filters.length, localizedMessages)
            }, options.gridFilterModel.columns);

            mappedFilter.operators = XPortal.GridFiltering.Operators["string"];
            if ((mappedFilter.operators || []).length > 0) mappedFilter.operator = mappedFilter.operators[0].value;
            mappedFilter.conditionDropDown = options.gridFilterModel.filters.length > 0 ? localizedMessages.and : localizedMessages.where;
            mappedFilter.conditions = XPortal.GridFiltering.conditionsDropDown(options.gridFilterModel.filters.length);
            return mappedFilter;
        },
        CreateDefaultFilterToGroup: function (options) {
            options = options ? options : { element: e.data.element, gridFilterModel: e.data.gridFilterModel };
            var field = { field: options.gridFilterModel.columns[0].field };
            var mappedFilter = XPortal.GridFiltering.MapFilterRow({
                row: field, filters: [field]
            }, options.gridFilterModel.columns);

            if ((mappedFilter.operators || []).length > 0) mappedFilter.operator = mappedFilter.operators[0].value;
            var groupElements = XPortal.EntityFilterPicker.GetGroupElements(options.gridFilterModel.filters);
            mappedFilter.conditionDropDown = groupElements.filter(f => f.field.toLowerCase() === mappedFilter.field.toLowerCase()).length > 0 ? localizedMessages.or : localizedMessages.and;
            mappedFilter.conditions = XPortal.GridFiltering.conditionsDropDown(options.gridFilterModel.filters.length);
            mappedFilter.hideCondition = false;
            return mappedFilter;
        },
        UpdateConditions: function (filters) {
            for (var i = 0; i < filters.length; i++) {
                filters[i].conditions = XPortal.GridFiltering.conditionsDropDown(i);
            }
            return filters;
        },
        UpdateEditable: function (filters, editable) {
            filters.forEach(f => { f.notEditable = !editable; });
            return filters;
        },
        Call: function (options, sucessCallback, completeCallback, errCallBack) {
            return jQuery.ajax({
                method: "POST", dataType: "json", cache: false, contentType: 'application/json; charset=utf-8',
                url: XPortal.Utils.EnsureInProfile(options.url), data: options.data, headers: options.headers ? options.headers : { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
                success: function (xdata) {
                    if (sucessCallback) sucessCallback(options, xdata);
                },
                complete: function (xdata) {
                    if (completeCallback) completeCallback(options, xdata);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (errCallBack) errCallBack(options, {}, jqXHR, textStatus, errorThrown);
                }
            });
        },
        Localize: function () {
            var startKey = "XPortal.Frontend.Filter.";
            for (var i in localizedMessages)
                localizedMessages[i] = XPortal.Localization.GetCachedString(startKey + i, localizedMessages[i]);
            XPortal.GridFiltering._localizeOperator(self.AdditionalDateOperators, "AdditionalDateOperators.", startKey + "Operators.");
            XPortal.GridFiltering._localizeOperator(self.AdditionalDateTimeOperators, "AdditionalDateOperators.", startKey + "Operators.");
            return true;
        }
    };
    return self;
}());
